import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { Storage } from '@ionic/storage';

import { PlayPage } from '../play/play'; 
import { HomePage } from '../home/home';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-survey',
  templateUrl: 'survey.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class SurveyPage {
  difficulty: string;
  language: string;
  settingsChanged:boolean;

  constructor(public rubedoSideMenu: MenuController, public functions: Functions, public translate: TranslateService, public navCtrl: NavController, private storage: Storage) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    
    this.difficulty = '';
    this.language = '';
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  /* --------- LIFECYCLE --------- */
  ionViewWillLeave(){
    //before the page leaves the viewport
    this.functions.setDifficulty();
    this.functions.setLanguage();
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
    this.functions.getDifficulty();
    this.functions.getLanguage();
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }
  /* --------- END LIFECYCLE --------- */
}



// WEBPACK FOOTER //
// ./src/pages/survey/survey.ts